import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Loader from './components/loader/Loader';
import { store } from './store/index';
import './utils/i18next';
import ReactGA from 'react-ga4';

if (process.env.NODE_ENV === 'production') ReactGA.initialize('G-BP4KZ91DYC');

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);
